/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import { ReactRoute } from 'embercom/lib/react-route';

export default class AutomationTracingConversationsWithIdRoute extends ReactRoute(Route) {
  @service declare router: RouterService;
  @service declare appService: AppService;

  analytics = {
    place: 'automation-tracing-conversations-with-id',
    section: 'automation',
  };

  reactEnabled(): boolean {
    return true;
  }

  beforeModel() {
    if (!this.appService.app.canUseWorkflowsConversationTracingTool) {
      this.router.transitionTo('apps.app.automation');
    }
  }

  model(params: { conversation_id: string }) {
    return {
      conversationId: params.conversation_id,
    };
  }
}
